import AgencyDetailsSticky from './agency-details-sticky';

export default AgencyDetailsSticky;
